import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const LUHN_INVALID = 'luhnInvalid';

export function luhnValidator(): ValidatorFn {
  const isLuhnValid = (val: any) => {
    if (val === undefined || !val) {
      return false;
    }

    let sum = 0;
    `${val}`
      .replaceAll(' ', '')
      .split('')
      .reverse()
      .forEach((num: any, i: any) => {
        num = parseInt(num, 10);
        if (i % 2 !== 0) {
          num *= 2;
          if (num > 9) {
            num = (num % 10) + 1;
          }
        }
        sum += num;
      });

    return sum % 10 === 0;
  };

  return (control: AbstractControl): ValidationErrors | null => {
    const valid = isLuhnValid(control.value);
    return !valid ? { [LUHN_INVALID]: { value: control.value } } : null;
  };
}
